// extracted by mini-css-extract-plugin
export default {"block":"WorkshopSwitch_block__z9ktC","souz":"WorkshopSwitch_souz__0abaZ","gorki":"WorkshopSwitch_gorki__wAWsU"};